import Vue from 'vue'
import template from './index.pug'
import {mapGetters} from 'vuex'
// @vue/component
export default Vue.extend({
  template: template(),

  props: {
    fare: {
      type: Object,
      default: () => {}
    },

    clickable: {
      type: Boolean,
      default: false
    }
  },
  
  methods: {
    handleClick() {
      this.$emit('click')
    },

    handleButtonClick() {
      this.$emit('button-click')
    }
  }
})
